import { Injectable } from '@angular/core';

// import { HeroJobAdComponent }   from './hero-job-ad.component';
// import { HeroProfileComponent } from './hero-profile.component';
// import { UscHeaderComponent } from '../components/usc-store/usc-header/usc-header.component';
import { HeaderItem } from '../components/header/header-item';

@Injectable()
export class HeaderService {
  //   getAvailableHeaders() {
  //   return [
  //     new HeaderItem(UscHeaderComponent, {name: 'usc-store-header'})
  //   ];
  // }
}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/services/header.service.ts